/**
 * @version 1.0.0
 * @since 1.0.0
 * @author Alex Dinari <alex.dinari@aofl.com>
 */
import {Sdo, storeInstance, state} from '@aofl/store';

/**
 * @type {String}
 * @private
 */
const NAMESPACE = 'home';

/**
 * @extends {Sdo}
 */
class HomeSdo extends Sdo {
  /**
   * @static
   * @type {String}
   */
  static namespace = NAMESPACE;

  /**
   * @static
   * @type {String}
   */
  @state()
  ddMenuColor = 'blue'
}

/**
 * @type {HomeSdo}
 */
const homeSdo = new HomeSdo();
storeInstance.addState(homeSdo);

export {
  homeSdo
};
